import React from 'react'
import { useNavigate } from 'react-router-dom'
import './MenuScreen.css'

// Main menu, drawn from public/ice-assets/menu/.
// menu-bg.png is the whole screen — scene, cyan rule, LOJA panel and bottom bar
// are painted into it — so this file only places the parts that have to be live
// (the six buttons, the gift, the credit counter, the wheel and the ranking box)
// exactly over their counterparts in that image. The measurements behind those
// positions are documented in MenuScreen.css.
const MENU = `${process.env.PUBLIC_URL}/ice-assets/menu`

const art = (name) => ({ backgroundImage: `url(${MENU}/${name}.png)` })

const BUTTONS = [
    { key: 'jogar', label: 'JOGAR' },
    { key: 'avaliar', label: 'AVALIAR' },
    { key: 'jogos', label: '+ JOGOS' },
    { key: 'suporte', label: 'SUPORTE' },
    { key: 'ajuda', label: 'AJUDA' },
    { key: 'sair', label: 'SAIR' },
]

function MenuScreen({ title = 'LOJA', credits = 10000, wheelLabel = 'GIRAR!', onSelect }) {
    const navigate = useNavigate()

    /* JOGAR is the way into the game — what the lobby tile used to do directly,
       before the splash and this menu were put in front of it. A parent that
       passes onSelect takes over every button, this one included. */
    const pick = (key) => () => {
        if (onSelect) {
            onSelect(key)
            return
        }
        if (key === 'jogar') navigate('/halloween-ice')
    }

    return (
        <div className='ice-menu-wrapper' style={art('menu-bg')}>
            {/* the panel is painted into the background, its title is not */}
            <div className='im-header'>{title}</div>

            <nav className='im-grid'>
                {BUTTONS.map((b) => (
                    <button
                        key={b.key}
                        type='button'
                        className='im-btn'
                        style={art('menu-button')}
                        onClick={pick(b.key)}
                    >
                        {/* the label is condensed by transform, so it needs its
                            own box — squeezing the button would squeeze its art */}
                        <span className='im-btn-label'>{b.label}</span>
                    </button>
                ))}
            </nav>

            <div className='im-bar-items'>
                {/* daily gift */}
                <button
                    type='button'
                    className='im-gift'
                    style={art('im-gift')}
                    title='Presente'
                    aria-label='Presente'
                    onClick={pick('gift')}
                />

                {/* credit counter: the plate is the button art, the coin its own
                    asset, and only the number is live. The coin goes through
                    art() like every other asset here — a bare relative src
                    breaks once the app is served from a sub-path. */}
                <div className='im-credits' style={art('menu-button')}>
                    <span className='im-coin' style={art('coin')} aria-hidden='true' />
                    <span className='im-credits-num im-num'>{credits}</span>
                </div>

                {/* prize wheel: plate + the disc overhanging it, label is live so
                    it can show either GIRAR! or the countdown */}
                <button
                    type='button'
                    className='im-wheel'
                    style={art('menu-button')}
                    onClick={pick('wheel')}
                >
                    <span className='im-wheel-face' style={art('im-wheel')} aria-hidden='true' />
                    <span className='im-wheel-label im-num'>{wheelLabel}</span>
                </button>

                {/* ranking */}
                <button
                    type='button'
                    className='im-chart'
                    style={art('im-chart')}
                    title='Ranking'
                    aria-label='Ranking'
                    onClick={pick('ranking')}
                />
            </div>
        </div>
    )
}

export default MenuScreen
